// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2j653","error":"Textarea_error__3REsY","readonly":"Textarea_readonly__1EUPM","disabled":"Textarea_disabled__2uVGr"};